var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 1.66666H1.66634C1.44533 1.66666 1.23337 1.75445 1.07709 1.91073C0.920805 2.06701 0.833008 2.27898 0.833008 2.49999V8.33332C0.833008 8.55434 0.920805 8.7663 1.07709 8.92258C1.23337 9.07886 1.44533 9.16666 1.66634 9.16666H7.49967C7.72069 9.16666 7.93265 9.07886 8.08893 8.92258C8.24521 8.7663 8.33301 8.55434 8.33301 8.33332V5.41666",
    stroke: "#4F4F4F",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70801 1.04166C7.87377 0.875899 8.09859 0.782776 8.33301 0.782776C8.56743 0.782776 8.79225 0.875899 8.95801 1.04166C9.12377 1.20742 9.21689 1.43224 9.21689 1.66666C9.21689 1.90108 9.12377 2.1259 8.95801 2.29166L4.99967 6.24999L3.33301 6.66666L3.74967 4.99999L7.70801 1.04166Z",
    stroke: "#4F4F4F",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.17beb607b829f384cb9daeeb9869c097.svg";
export { ForwardRef as ReactComponent };